import { render, staticRenderFns } from "./LongLabels.vue?vue&type=template&id=4eabb09c"
import script from "./LongLabels.vue?vue&type=script&lang=js"
export * from "./LongLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports